"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVAR109_NAME = exports.INFO_MODULE = exports.CMP = exports.CLIENT_ID_COOKIE_NAME = exports.ADBLOCK_COOKIE_NAME = exports.NO_LOGADO = exports.LOGADO = exports.NEW = exports.REPEAT = exports.NO = exports.SI = exports.NO_AMP = exports.NO_INFO = exports.NO_APLICA = void 0;
var NO_APLICA = 'no aplica';
exports.NO_APLICA = NO_APLICA;
var NO_INFO = 'no informado';
exports.NO_INFO = NO_INFO;
var NO_AMP = 'no AMP';
exports.NO_AMP = NO_AMP;
var SI = 'si';
exports.SI = SI;
var NO = 'no';
exports.NO = NO;
var REPEAT = 'repeat';
exports.REPEAT = REPEAT;
var NEW = 'new';
exports.NEW = NEW;
var LOGADO = 'Logado';
exports.LOGADO = LOGADO;
var NO_LOGADO = 'No logado';
exports.NO_LOGADO = NO_LOGADO;
var ADBLOCK_COOKIE_NAME = 'ABR_DL';
exports.ADBLOCK_COOKIE_NAME = ADBLOCK_COOKIE_NAME;
var CLIENT_ID_COOKIE_NAME = 'comunidadIdentifier';
exports.CLIENT_ID_COOKIE_NAME = CLIENT_ID_COOKIE_NAME;
var CMP = {
  accept: 'aceptado',
  configAccept: 'configuracion:aceptado',
  configRejected: 'configuracion:rechazado',
  configCustom: 'configuracion:personalizado',
  notAnswer: 'no respondido'
}; // Keys sessionStorage

exports.CMP = CMP;
var INFO_MODULE = 'infoModule';
exports.INFO_MODULE = INFO_MODULE;
var EVAR109_NAME = 'respuestaCmp';
exports.EVAR109_NAME = EVAR109_NAME;